$(document).ready(function () {

     
    $(".CurrencyItem").live("click", function () {

        $(".CurrencyItem").removeClass("active");
        $(this).addClass("active");

    });

    var currencyID = $('input[name=currencyID]:checked').val();

    if (currencyID == undefined || currencyID == null)
    {
        $(".CurrencyItem").first().find(".currencyID").attr("checked", "checked");
        $(".CurrencyItem").first().addClass("active");
    }

    $(document).on("click", "#CurrencySelectFromBar", function (e) {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")
         
       

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + $("#Url").val() + "&currencyID=" + $('input[name=currencyID]:checked').val() + "&hash=" + window.location.hash + "&countryCode=" + $("#CountryCode").val(),
            success: function (dt) {

                //window.location.reload(true);
               window.parent.location.href = dt;

            }
        });


    });


});